// extracted by mini-css-extract-plugin
export default {"loginPage":"login-page_loginPage__xfQU6","loginPageForm":"login-page_loginPageForm__+TZKr"};